import { backdropClasses, modalUnstyledClasses, popoverClasses } from '@mui/material';

const OPEN_POPOVER_BACKDROP_SELECTOR = `.${popoverClasses.root}:not(.${modalUnstyledClasses.hidden}) > .${backdropClasses.root}`;

/**
 * Dismisses every open MUI popover by clicking its backdrop
 * The same path a real user click takes.
 */
export const closePopovers = (doc: Document = document): void => {
  const backdrops = Array.from(doc.querySelectorAll<HTMLElement>(OPEN_POPOVER_BACKDROP_SELECTOR));
  backdrops.reverse().forEach((backdrop) => backdrop.click());
};
